import type { SVGProps } from 'react';

const IconPlayCircleFill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.65 15.7501L15.525 12.6251C15.7583 12.4751 15.875 12.2668 15.875 12.0001C15.875 11.7335 15.7583 11.5251 15.525 11.3751L10.65 8.25012C10.4 8.08346 10.1458 8.07096 9.8875 8.21262C9.62917 8.35429 9.5 8.57512 9.5 8.87512V15.1251C9.5 15.4251 9.62917 15.646 9.8875 15.7876C10.1458 15.9293 10.4 15.9168 10.65 15.7501ZM12 22.0001C10.6167 22.0001 9.31667 21.7376 8.1 21.2126C6.88333 20.6876 5.825 19.9751 4.925 19.0751C4.025 18.1751 3.3125 17.1168 2.7875 15.9001C2.2625 14.6835 2 13.3835 2 12.0001C2 10.6168 2.2625 9.31679 2.7875 8.10012C3.3125 6.88346 4.025 5.82512 4.925 4.92512C5.825 4.02512 6.88333 3.31262 8.1 2.78762C9.31667 2.26262 10.6167 2.00012 12 2.00012C13.3833 2.00012 14.6833 2.26262 15.9 2.78762C17.1167 3.31262 18.175 4.02512 19.075 4.92512C19.975 5.82512 20.6875 6.88346 21.2125 8.10012C21.7375 9.31679 22 10.6168 22 12.0001C22 13.3835 21.7375 14.6835 21.2125 15.9001C20.6875 17.1168 19.975 18.1751 19.075 19.0751C18.175 19.9751 17.1167 20.6876 15.9 21.2126C14.6833 21.7376 13.3833 22.0001 12 22.0001Z"
      fill="#09B40F"
    />
  </svg>
);

export default IconPlayCircleFill;
